import * as t from 'io-ts';
import { Leaf } from './leaf';
export var All = t.recursion('All', function () {
  return t.type({
    $all: t.array(Aql)
  });
});
export var Any = t.recursion('Any', function () {
  return t.type({
    $any: t.array(Aql)
  });
});
export var Not = t.recursion('Not', function () {
  return t.type({
    $not: Aql
  });
});
export var Aql = t.recursion('Aql', function () {
  return t.union([Leaf, All, Any, Not]);
});